import {defineStore} from 'pinia'
import CustomStore from "devextreme/data/custom_store";
import {ref} from "vue";
import axios from "axios";
import {API_BASE_URL} from "@/global-constants";
import api from "@/api";
import {DateTime} from "luxon";
//import ODataStore from "devextreme/data/odata/store";
export const useBacameterStore = defineStore(
    'bacameterStore',
    () => {
        const selectedBulanBacaDataGrid = ref(DateTime.local().minus({ months: 1 }).toFormat('yyyyLL'));
        const selectedRangeDataGrid = ref(3);
        const latestAccessTime = ref(null);
        const pemakaianNolCustomStore = new CustomStore({
            load: async (loadOptions) => {
                // your custom parameters
                let params = {};
                if (loadOptions.sort) {
                    params.sort = JSON.stringify(loadOptions.sort);
                }
                if (loadOptions.filter) {
                    params.filter = JSON.stringify(loadOptions.filter);
                }
                if (loadOptions.skip) {
                    params.skip = loadOptions.skip;
                }
                if (loadOptions.take) {
                    params.take = loadOptions.take;
                }

                params.periodeRange = selectedRangeDataGrid.value;
                params.periodeRangeStart = selectedBulanBacaDataGrid.value;


                const response = await axios.get(`${API_BASE_URL}/pemakaian-nol-list`, {
                    params: params,
                    headers: {
                        Authorization: api.defaults.headers.common['Authorization'],
                        'Content-Type': 'application/json',
                    },
                });

                latestAccessTime.value = null;
                if (response.data) {
                    latestAccessTime.value = response.data.serverTime;
                    return {
                        data: response.data.data,
                        totalCount: response.data.totalCount,
                    };
                }

                throw 'Data loading error';
            },
        });

        function setSelectedBulanBacaDataGrid(value) {
            selectedBulanBacaDataGrid.value = value;
        }

        function setSelectedRangeDataGrid(value) {
            selectedRangeDataGrid.value = value;
        }

        return {
            pemakaianNolCustomStore,
            latestAccessTime,
            selectedBulanBacaDataGrid,
            selectedRangeDataGrid,
            setSelectedBulanBacaDataGrid,
            setSelectedRangeDataGrid
        }
    });